import Promise from 'bluebird';

import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';

import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { ResponsiveAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import state from '@bingads-webui-component-legacy/state/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import Constants from '@bingads-webui-static-legacy/constants';
import UrlEditor from '@bingads-webui-component-legacy/url-input/view/url-input';
import UrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/urlOptionsV2';
import * as TestUurl from '@bingads-webui-component-legacy/upgraded-url/service/testUurl';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import ActionLanguageAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/language-adapter';
import ActionTypeAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/action-type-adapter';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import preferences from '@bingads-webui-component-legacy/preference/service/index';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/audience-campaign');

DependencyResolver.set('component/js-data-campaign/index', jsdata);
DependencyResolver.set('$/schema!campaign/ResponsiveAd', ResponsiveAd);
DependencyResolver.set('component/i18n/loader!campaignui/feature/audience-campaign', i18n);
DependencyResolver.set('component/url-input/view/url-input', UrlEditor);
DependencyResolver.set('component/api-errors-campaign/index', i18nErrors);
DependencyResolver.set('component/upgraded-url/view/urlOptionsV2', UrlOptions);
DependencyResolver.set('component/upgraded-url/service/testUurl', TestUurl);
DependencyResolver.set('component/state/index', state);
DependencyResolver.set('component/http/channel/odata', odata);
DependencyResolver.set('component/config/index', config);
DependencyResolver.set('Constants', Constants);
DependencyResolver.set('component/edm-campaign/index', edmCampaign);
DependencyResolver.set('campaignui/feature/adextension/actionlink/view/language-adapter', ActionLanguageAdapter);
DependencyResolver.set('campaignui/feature/adextension/actionlink/view/action-type-adapter', ActionTypeAdapter);
DependencyResolver.set('campaignui/feature/instrumentation/index', instrumentation);
DependencyResolver.set('component/preference/service/index', preferences);

let loadResponsiveAdEditorPromise = null;

const loadResponsiveAdEditorAsync = () => {
  if (!loadResponsiveAdEditorPromise) {
    loadResponsiveAdEditorPromise = new Promise((resolve) => {
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/responsive-ad-editor')
        .then((ResponsiveAdEditorModule) => {
          resolve(ResponsiveAdEditorModule.ResponsiveAdEditor);
        });
    });
  }

  return loadResponsiveAdEditorPromise;
};

export { loadResponsiveAdEditorAsync };
